import { render, staticRenderFns } from "./DownloadBanner.vue?vue&type=template&id=32729fc3"
import script from "./DownloadBanner.vue?vue&type=script&lang=js"
export * from "./DownloadBanner.vue?vue&type=script&lang=js"
import style0 from "./DownloadBanner.vue?vue&type=style&index=0&id=32729fc3&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports